import { Country, State, City } from "country-state-city";
import CodeData from "../json/CodeData";

export const updatedCountries = Country.getAllCountries().map((country) => ({
    key: country.isoCode,
    value: country.isoCode,
    label: country.name,
}));

export const updatedStates = (countryCode) =>
    State.getStatesOfCountry(countryCode).map((state) => ({
        key: state.isoCode,
        value: state.isoCode,
        label: state.name,
    }));

export const updatedCities = (countryCode, stateCode) =>
    City.getCitiesOfState(countryCode, stateCode).map((city) => ({
        key: `${city.latitude}*${city.longitude}`,
        value: `${city.latitude}*${city.longitude}`,
        label: city.name,
    }));

export const getStateCode = (state_name) => {
    if (!state_name) return "";
    
    const state = CodeData.GstStateCode.find((o) => o.state_name === state_name) || {};
    return state?.state_code || "";
};
